import { useState } from 'react';

export default function ArticleSidebar() {
  const [email, setEmail] = useState('');

  return (
    <div className="space-y-8">
      {/* Author Info */}
      <div className="bg-white rounded-xl p-6 border border-gray-200">
        <div className="flex items-center gap-4 mb-4">
          <div className="w-16 h-16 rounded-full bg-gradient-to-br from-green-500 to-teal-600 flex items-center justify-center text-white font-bold text-lg">
            BM
          </div>
          <div>
            <h3 className="text-lg font-bold text-gray-900">Bảo Minh</h3>
            <p className="text-sm text-gray-600">Chuyên gia Bảo hiểm</p>
          </div>
        </div>
        <p className="text-sm text-gray-700 mb-4">
          15 năm kinh nghiệm tư vấn bảo hiểm quốc tế, đã xử lý hơn 5,000 case bồi thường cho khách du lịch tại Mỹ và các quốc gia khác.
        </p>
        <div className="grid grid-cols-2 gap-4 text-center">
          <div className="bg-green-50 p-3 rounded-lg">
            <div className="text-xl font-bold text-green-600">5,000+</div>
            <div className="text-xs text-gray-600">Case xử lý</div>
          </div>
          <div className="bg-blue-50 p-3 rounded-lg">
            <div className="text-xl font-bold text-blue-600">98%</div>
            <div className="text-xs text-gray-600">Thành công</div>
          </div>
        </div>
      </div>

      {/* Quick Navigation */}
      <div className="bg-white rounded-xl p-6 border border-gray-200">
        <h3 className="text-lg font-bold text-gray-900 mb-4">Nội dung chính</h3>
        <nav className="space-y-2">
          {[
            { title: 'Tại sao cần bảo hiểm?', id: 'overview' },
            { title: 'Loại bảo hiểm phù hợp', id: 'types' },
            { title: 'Nhà cung cấp uy tín', id: 'providers' },
            { title: 'Quy trình bồi thường', id: 'claims' }
          ].map((item, index) => (
            <a
              key={index}
              href={`#${item.id}`}
              className="block text-sm text-gray-600 hover:text-green-600 transition-colors py-1"
            >
              {item.title}
            </a>
          ))}
        </nav>
      </div>

      {/* Featured Tours */}
      <div className="bg-white rounded-xl p-6 border border-gray-200">
        <h3 className="text-lg font-bold text-gray-900 mb-4">Tour có bảo hiểm toàn diện</h3>
        <div className="space-y-4">
          {[
            {
              title: 'Tour Bờ Đông 12 ngày',
              image: 'https://public.readdy.ai/ai/img_res/41778708521d43ba418367927045870e.jpg',
              price: 'Từ $2,999',
              highlight: 'Bảo hiểm $1M',
              badge: 'An toàn'
            },
            {
              title: 'California Coast 10 ngày', 
              image: 'https://readdy.ai/api/search-image?query=California%20Pacific%20Coast%20Highway%20scenic%20drive%20with%20Golden%20Gate%20Bridge%20in%20distance%2C%20coastal%20cliffs%20and%20ocean%20views%2C%20beautiful%20California%20landscape%20perfect%20for%20travel%20insurance%20coverage%20promotion&width=400&height=250&seq=california-coast-insurance&orientation=landscape',
              price: 'Từ $2,799',
              highlight: 'Medical $500K',
              badge: 'Bảo vệ'
            },
            {
              title: 'National Parks 14 ngày',
              image: 'https://readdy.ai/api/search-image?query=Yellowstone%20National%20Park%20Old%20Faithful%20geyser%20eruption%20with%20tourists%20watching%20safely%20from%20designated%20viewing%20area%2C%20natural%20American%20wonder%20with%20safety%20barriers%20and%20park%20ranger%20presence%20for%20insurance%20coverage&width=400&height=250&seq=national-parks-insurance&orientation=landscape',
              price: 'Từ $3,299',
              highlight: 'Toàn diện',
              badge: 'Premium'
            }
          ].map((tour, index) => (
            <div key={index} className="relative group cursor-pointer">
              <div className="w-full h-32 rounded-lg overflow-hidden mb-3">
                <img
                  src={tour.image}
                  alt={tour.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="absolute top-2 right-2">
                <span className="bg-green-600 text-white text-xs font-medium px-2 py-1 rounded-full">
                  {tour.badge}
                </span>
              </div>
              <h4 className="font-semibold text-gray-900 mb-1">{tour.title}</h4>
              <div className="flex items-center justify-between">
                <span className="text-green-600 font-bold">{tour.price}</span>
                <span className="text-xs text-gray-500">{tour.highlight}</span>
              </div>
            </div>
          ))}
        </div>
        <button className="w-full mt-4 bg-green-600 text-white py-2.5 rounded-lg font-medium hover:bg-green-700 transition-colors cursor-pointer">
          Xem tất cả tour
        </button>
      </div>

      {/* Insurance Calculator */}
      <div className="bg-gradient-to-br from-blue-600 to-teal-700 rounded-xl p-6 text-white">
        <div className="text-center mb-4">
          <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center">
            <i className="ri-calculator-line text-3xl"></i>
          </div>
          <h3 className="text-lg font-bold mb-2">Tính phí bảo hiểm</h3>
          <p className="text-sm text-white/90">
            Nhập thông tin để nhận báo giá chính xác
          </p>
        </div>
        
        <div className="space-y-3">
          <select className="w-full px-3 py-2 rounded-lg text-gray-900 text-sm">
            <option>Độ tuổi của bạn</option>
            <option>18-25 tuổi</option>
            <option>26-35 tuổi</option>
            <option>36-50 tuổi</option>
            <option>51-65 tuổi</option>
            <option>Trên 65 tuổi</option>
          </select>
          
          <select className="w-full px-3 py-2 rounded-lg text-gray-900 text-sm">
            <option>Thời gian du lịch</option>
            <option>5-10 ngày</option>
            <option>11-20 ngày</option>
            <option>21-30 ngày</option>
            <option>Trên 30 ngày</option>
          </select>
          
          <select className="w-full px-3 py-2 rounded-lg text-gray-900 text-sm">
            <option>Loại bảo hiểm</option>
            <option>Cơ bản ($50K)</option>
            <option>Toàn diện ($250K)</option>
            <option>Cao cấp ($1M)</option>
          </select>
        </div>
        
        <button className="w-full mt-4 bg-white text-blue-700 py-2.5 rounded-lg font-semibold hover:bg-gray-50 transition-colors cursor-pointer">
          Tính phí ngay
        </button>
      </div>

      {/* Newsletter */}
      <div className="bg-white rounded-xl p-6 border border-gray-200">
        <div className="text-center mb-4">
          <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center bg-green-100 rounded-lg">
            <i className="ri-mail-line text-2xl text-green-600"></i>
          </div>
          <h3 className="text-lg font-bold text-gray-900 mb-2">Tips bảo hiểm hằng tuần</h3>
          <p className="text-sm text-gray-600">
            Nhận hướng dẫn chi tiết và cập nhật mới nhất về bảo hiểm du lịch
          </p>
        </div>
        
        <form className="space-y-3">
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Email của bạn"
            className="w-full px-4 py-2.5 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-green-500 focus:border-green-500"
          />
          <button
            type="submit"
            className="w-full bg-green-600 text-white py-2.5 rounded-lg font-medium hover:bg-green-700 transition-colors cursor-pointer"
          >
            Đăng ký nhận tips
          </button>
        </form>
        
        <div className="flex items-center gap-2 mt-3 text-xs text-gray-500">
          <i className="ri-shield-check-line text-green-600"></i>
          <span>Không spam • Hủy đăng ký bất cứ lúc nào</span>
        </div>
      </div>

      {/* Expert Support */}
      <div className="bg-gradient-to-br from-orange-600 to-red-600 rounded-xl p-6 text-white text-center">
        <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center">
          <i className="ri-customer-service-2-line text-3xl"></i>
        </div>
        <h3 className="text-lg font-bold mb-2">Hỗ trợ 24/7</h3>
        <p className="text-sm text-white/90 mb-4">
          Cần tư vấn bảo hiểm hoặc hỗ trợ claim khẩn cấp?
        </p>
        <div className="space-y-2">
          <button className="w-full bg-white text-orange-700 py-2.5 rounded-lg font-semibold hover:bg-gray-50 transition-colors cursor-pointer">
            Gọi ngay: 1900-xxxx
          </button>
          <button className="w-full bg-white/10 backdrop-blur-sm border border-white text-white py-2.5 rounded-lg font-semibold hover:bg-white/20 transition-colors cursor-pointer">
            Chat với chuyên gia
          </button>
        </div>
      </div>

      {/* Related Articles */}
      <div className="bg-white rounded-xl p-6 border border-gray-200">
        <h3 className="text-lg font-bold text-gray-900 mb-4">Bài viết liên quan</h3>
        <div className="space-y-4">
          {[
            {
              title: 'Visa du lịch Mỹ 2025',
              time: '8 phút đọc',
              link: '/visa-us-guide'
            },
            {
              title: 'Thuê xe & lái xe tại Mỹ',
              time: '12 phút đọc', 
              link: '/car-rental-guide'
            },
            {
              title: 'Chi phí du lịch Mỹ',
              time: '6 phút đọc',
              link: '#'
            }
          ].map((article, index) => (
            <a
              key={index}
              href={article.link}
              className="block p-3 rounded-lg hover:bg-gray-50 transition-colors group"
            >
              <h4 className="text-sm font-medium text-gray-900 group-hover:text-green-600 mb-1">
                {article.title}
              </h4>
              <p className="text-xs text-gray-500">{article.time}</p>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}